/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useDatasetsTabStyles = makeStyles((theme: Theme) => ({
  root: {},
  importButton: {
    textTransform: 'none',
    fontSize: '14px',
    padding: '6px 4px',
  },
  noDatasets: {
    margin: '20px 0 40px 0',
    color: theme.palette.grey[400],
  },
  loaderContainer: {
    height: '100%',
    maxHeight: '500px',
    minHeight: '150px',
  },
  noItemsLabel: {
    margin: '20px 0',
    letterSpacing: '-0.09px',
    fontSize: '12px',
    lineHeight: '15px',
    fontWeight: 500,
  },
}));

export { useDatasetsTabStyles };
